import { twMerge } from 'tailwind-merge'
import { ISection } from '../../models/ISection'
import Post from '../components/Post'
import Link from 'next/link';
import SectionTitle from '../components/SectionTitle';

export default function SectionTwo(data: ISection) {
  if (!data?.posts?.length) return null;
  return (
      <section key={data.internalName}>
      {data.showTitle && data.title ? <SectionTitle title={data.title} href={`/${data.targetSlug}`} target='_self'/> : null}

       <div className='grid grid-cols-1 tablet:grid-cols-2 gap-[24px]'>
        {data.posts.map((p,i) => {
          return (
          <Post 
          isLarge={i <= 1}
               badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
          newsType={p.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={p.type} 
            title={p.title}
            image={{src: p.imageUrls.url, fill: true, sizes: '100vw', className: 'rounded-tr-[12px] rounded-tl-[12px]', alt: p.imageAlt || '', ...(data.eager ? {priority: true, loading: 'eager'} : {})}} 
            category={p.category} 
            uniqueCode={p.uniqueCode}
            hide={{category: true}}
            classNames={{contentContainer: 'p-[16px] flex-1', image: twMerge('mb-0'), title: 'h3 line-clamp-2', wrapper: 'flex-1 rounded-[12px]'}}
            thumbnail={p.imageUrls.thumbUrl}
          />
        )})}
       </div>

              <Link href={`/${data.targetSlug}`} className={twMerge('rounded-[6px] grid place-items-center w-fit px-[12px] h-[36px] cursor-pointer transition-all duration-300 hover:scale-[103%] self-end ml-[24px] desktop:ml-0 bg-gray-100 dark:bg-quaternary')}>
      <span className='text-dark dark:text-white h6'>المزيد</span>
    </Link>
      </section>
  )
}